module.exports = __webpack_public_path__ + "media/gifts/gift-vivier-8ac5a40f.png";